import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Button, Col, Input, Row } from 'reactstrap';

const Pagination = ({
  perPage = 10,
  perPageOptions = [10, 30, 50, 100],
  lastPage = 1,
  page = 1,
  onPerPageChanged,
  onPageChanged
}) => {
  const { t } = useTranslation();
  const perPageChangedHandler = (e) => {
    if (onPerPageChanged) onPerPageChanged(e.target.value);
  };

  return (
    <Row className="flex-wrap">
      <Col className="fs--1 d-none d-md-block">
        <Input
          value={perPage}
          onChange={perPageChangedHandler}
          type="select"
          id="paginationPerPage"
          name="perPage"
          bsSize="sm"
          className="!w-fit"
        >
          {perPageOptions.map((option, index) => (
            <option value={option} key={index}>
              {option}
            </option>
          ))}
        </Input>
      </Col>
      <Col className="d-flex fs--1 justify-content-center align-items-center">
        <span className="text-nowrap">
          {t('Page')} {page} {lastPage ? `${t('of')} ${lastPage}` : ''}
        </span>
      </Col>
      <Col className="d-flex gap-2 justify-content-sm-end justify-content-center">
        <Button
          color={page === 1 ? 'light' : 'primary'}
          size="sm"
          onClick={() => onPageChanged && onPageChanged(page - 1)}
          disabled={page === 1}
          className="px-4"
        >
          <Trans>Previous</Trans>
        </Button>
        <Button
          color={page >= lastPage ? 'light' : 'primary'}
          size="sm"
          onClick={() => onPageChanged && onPageChanged(page + 1)}
          disabled={page >= lastPage}
          className="px-4"
        >
          <Trans>Next</Trans>
        </Button>
      </Col>
    </Row>
  );
};

export default Pagination;
